import ModalHeader from '@modules/common/components/Modal/ModalHeader';
import { QueryBuilder } from '@modules/queryBuilder/components/QueryBuilder';
import { QueryBuilderActionsHandle } from '@modules/queryBuilder/components/QueryBuilder/QueryBuilder';
import { trackQBEvent } from '@modules/queryBuilder/events';
import { QueryOnChangeProps } from '@modules/queryBuilder/types';
import { DialogContent } from '@mui/material';
import { ReactNode, forwardRef } from 'react';
import useGetSourceDetailsMap from 'v2/core/repository/edge-server/source-details';
import { mapToEQL } from 'v2/core/repository/eql/mappers';
import { ExpressionType } from 'v2/core/repository/eql/types';
import {
  EmptyWhereClause,
  WhereClause,
} from 'v2/core/services/queryBuilder/whereClause';

interface WhereClauseModalContentProps {
  modalTitle?: ReactNode;
  whereClause?: WhereClause;
  onChange: (value: {
    whereClause: WhereClause;
    isQuickFilter?: boolean;
  }) => void;
  onClose: () => void;
  shouldSkipRender: boolean;
  forceEnableExecuteButton?: boolean;
  readOnly?: boolean;
}

export const WhereClauseModalContent = forwardRef<
  QueryBuilderActionsHandle,
  WhereClauseModalContentProps
>(
  (
    {
      modalTitle,
      whereClause,
      onClose,
      onChange,
      shouldSkipRender,
      forceEnableExecuteButton,
      readOnly,
    },
    forwardedRef,
  ) => {
    const { data: sourceDetailsMap } = useGetSourceDetailsMap();

    const onExecute = ({ whereClause, isQuickFilter }: QueryOnChangeProps) => {
      onChange({ whereClause, isQuickFilter });
      onClose();

      trackQBEvent({
        eventName: 'Query Builder Action Event',
        action: {
          type: 'EXECUTE_QUERY',
          eql: mapToEQL({
            whereClause: whereClause ?? EmptyWhereClause,
            expressionType: ExpressionType.Records,
            sourceDetailsMap: sourceDetailsMap ?? new Map(),
          }),
          display: '',
          searchMetadata: '',
          qbContext: 'Quantify',
        },
      });
    };

    return (
      <>
        <ModalHeader title={modalTitle || 'Add Filters'} onClose={onClose} />
        <DialogContent dividers>
          <QueryBuilder
            ref={forwardedRef}
            whereClause={whereClause}
            shouldSkipRender={shouldSkipRender}
            onExecute={onExecute}
            autoFocus
            forceEnableExecuteButton={forceEnableExecuteButton}
            readOnly={readOnly}
          />
        </DialogContent>
      </>
    );
  },
);
